export const PROGRAMMING_FILE_STATUS_OPTIONS = [
  'NUEVO PEDIDO',
  'LAST MINUTE',
  'REVISAR',
  'ANULADO',
  'POSTERGADO',
  'EN PROCESO',
  'CONFIRMADO',
  'RECONFIRMADO',
  'PROGRAMADO',
  'EN OPERACION',
  'OPERADO',
  'CERRADO'
] as const;

export const getProgrammingFileStatusPillClass = (
  state: string | null | undefined
): string => {
  const classesByState: Record<string, string> = {
    'NUEVO PEDIDO': 'pill-nuevo',
    'LAST MINUTE': 'pill-urgente',
    'REVISAR': 'pill-revisar',
    'ANULADO': 'pill-anulado',
    'POSTERGADO': 'pill-postergado',
    'EN PROCESO': 'pill-proceso',
    'CONFIRMADO': 'pill-confirmado',
    'RECONFIRMADO': 'pill-reconfirmado',
    'PROGRAMADO': 'pill-programado',
    'EN OPERACION': 'pill-operacion',
    'OPERADO': 'pill-operado',
    'CERRADO': 'pill-cerrado',
    'FILE': 'pill-file'
  };

  return classesByState[state ?? ''] ?? 'pill-file';
};
